<template>
    <button @click="redirect" type="button" class="btn btn-link-success font-weight-bold font-xs text-green">
        <slot></slot>
    </button>
</template>
<script>
import { ERROR } from '../mixins/error_codes.js';
export default {
    props: {
        opg2: Boolean,
        default: false
    },
    methods: {
        redirect() {
            let vm = this;
            if(vm.$root.transaction.isOpg2) {
                if(vm.$root.transaction.hasOwnProperty('failedUrl') && vm.$root.transaction.failedUrl != 'undefined') {
                    window.location.href = vm.$root.transaction.failedUrl;
                } else {
                    vm.$root.error = ERROR.TECHNICAL_PROBLEM;
                }
            } else {
                if(!this.$root.transaction.cancelURL || this.$root.transaction.cancelURL == 'undefined') {
                    if(this.$root.transaction.page == "lazada") {
                        this.redirectURL = "https://pages.lazada.com.ph/wow/gcp/route/lazada/ph/upr_1000345_lazada/channel/ph/upr-router/render?hybrid=1&data_prefetch=true&prefetch_replace=1&at_iframe=1&wh_pid=/lazada/channel/ph/lazada-wallet-loans/LazadaLoans";
                    } else {
                       this.redirectURL = this.$root.transaction.callBackURL;
                    }
                    window.location.href = this.redirectURL 
                } else {
                    window.location.href = this.$root.transaction.cancelURL;
                }
            }
        }
    }
}
</script>